import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../services";
import {ToastrService} from "ngx-toastr";
import {ActionsSubject} from "@ngrx/store";
import {ImageLoaderComponent} from "../image-loader/image-loader.component";
import {IAppStatic, IPreloadResellerInfo, IUser} from "../../interfaces";
import {Compbaser} from "../compbaser";
import {convertNumberToBoolean, DEFAULT_RESELLER_ID, isNullOrUndefOrEmpty} from "../../common";

@Component({
    selector: 'app-logo',
    styleUrls: ['./logo-component.scss'],
    templateUrl: './logo-component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent extends Compbaser {

    appStatic: IAppStatic;
    showCreateAccount = true;
    logoUrl: string;
    preLoginResellerInfo: IPreloadResellerInfo;
    isWhiteLabeled = false;
    resellerLogo: Array<any>;
    user: IUser;
    stylesObj = {
        img: {
            'width': '60px',
            'height': '39px',
            'background-size': '60px 39px',
            'display': 'block',
            'position': 'absolute',
            'left': '6px'
        }
    };

    @ViewChild('imgLoaderLogo', {static: true}) imgLoaderLogo: ImageLoaderComponent;

    @Input()
    set overrideDefaultClass(value) {
        if (value.length > 1) {
            this.stylesObj = value;
        } else if (value && value.img) {
            this.stylesObj = {
                img: value.img
            };
        } else {
            this.stylesObj = {
                img: null
            };
        }
    }

    constructor(private router: Router,
                private storeSelector: StoreSelectorsService,
                private localStoreService: LocalStoreService,
                private route: ActivatedRoute,
                private toastr: ToastrService,
                private appService: AppService,
                private actionsSubj: ActionsSubject,
                private cd: ChangeDetectorRef) {
        super();
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.user = user;
            })
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
        this.cod(
            this.storeSelector.getResellerId(this.localStoreService)
                .subscribe((i_resellerId: number) => {
                    if (i_resellerId === DEFAULT_RESELLER_ID) {
                        this.resellerLogo = [`${this.appStatic.protocol}${this.appStatic.masterServer}/Resources/Resellers/1/Logo.png?random=${Math.random()}`];
                    } else {
                        this.resellerLogo = [
                            `${this.appStatic.protocol}${this.appStatic.masterServer}/Resources/Resellers/${i_resellerId}/Logo.png?random=${Math.random()}`,
                            `${this.appStatic.protocol}${this.appStatic.masterServer}/Resources/Resellers/${i_resellerId}/Logo.jpg?random=${Math.random()}`];
                        this.isWhiteLabeled = true;
                    }
                    // Lib.DevShow('reseller id ' + i_resellerId);
                })
        );
    }

    goToHome(event) {
        if (isNullOrUndefOrEmpty(this.user) && this.isWhiteLabeled) {
            this.cod(
                this.storeSelector.getPreloginResellerInfo()
                    .subscribe((i_preLoginResellerInfo) => {
                        this.preLoginResellerInfo = i_preLoginResellerInfo;
                        if (!isNullOrUndefOrEmpty(this.preLoginResellerInfo?.custom_studio_json?.Application?.[0]?.Logo?.[0]?.$?.link)) {
                            window.open(this.preLoginResellerInfo?.custom_studio_json?.Application?.[0]?.Logo?.[0]?.$?.link, "_blank");
                        }
                    })
            );

        } else {
            this.appService.goToHomePage(true);
        }
    }
}




